import React from "react";
import { RedeemRequest } from "types/redeem";
import RedeemItem from "features/redeem/redeem-item/RedeemItem";
import SkeletonRedeemItem from "features/redeem/redeem-item/SkeletonRedeemItem";
import "./redeem-list.css";

interface Props {
  requests: RedeemRequest[];
  loading: boolean;
  /** Used only for a row the backend could not tag. Rows are filtered to the selected token
   *  server-side, but each still prefers its OWN symbol so a mislabel can never be introduced
   *  here if the filter is ever omitted. */
  fallbackTokenSymbol: string;
  onRefresh: () => void;
}

function RedeemList({
  requests,
  loading,
  fallbackTokenSymbol,
  onRefresh,
}: Props) {
  const requestsSorted = requests.sort(
    (a, b) => Number(b.createdAt) - Number(a.createdAt),
  );
  return (
    <section className="rdm-list">
      <div className="rdm-list__header">
        <h3 className="rdm-list__title">Pending Redeems</h3>
        {/* <button
          className={`v1-ico-btn${loading ? " rdm-list__refresh--spinning" : ""}`}
          onClick={onRefresh}
          disabled={loading}
          aria-label="Refresh redeem requests"
        >
          <RefreshIconV1 size={16} />
        </button> */}
      </div>

      {loading && requests.length === 0 ? (
        <div className="rdm-list__items">
          {Array.from({ length: 3 }, (_, i) => (
            <SkeletonRedeemItem key={i} />
          ))}
        </div>
      ) : requests.length === 0 ? (
        <div className="rdm-list__empty">No pending redeems.</div>
      ) : (
        <div className="rdm-list__items">
          {requestsSorted.map((r) => (
            <RedeemItem
              key={r.id}
              request={r}
              fallbackTokenSymbol={fallbackTokenSymbol}
            />
          ))}
        </div>
      )}
    </section>
  );
}

export default RedeemList;
